import { BodyFastAction } from '.'
import { ActionType } from './ActionTypes'

export interface OnboardingState {
  newsletterEmail: string | null
}

const INITIAL_STATE: OnboardingState = {
  newsletterEmail: null
}

export interface ISetNewsletterEmail { type: ActionType.SET_NEWSLETTER_EMAIL, email: string | null }

export type OnboardingAction =
  | ISetNewsletterEmail

export const OnboardingReducer = (state: OnboardingState = INITIAL_STATE, action: BodyFastAction): OnboardingState => {
  switch (action.type) {
    case ActionType.SET_NEWSLETTER_EMAIL:
      return { ...state, newsletterEmail: action.email }
    default:
      return state
  }
}
